import BBSearchForm from "./BBSearchForm"
import RecentFloorRequests from "./RecentFloorRequests"
import Breadcrumbs from "../../common/Breadcrumbs"
import useStore from "../../../store"

export default function Blackbook() {
  const user = useStore((state) => state.user)

  return(
    <div className="flex flex-col grow items-center overflow-y-auto w-full">
      <div className="relative w-full lg:w-1/2 grow overflow-x-hidden">
        {user?.type === 'AccountManager' && <Breadcrumbs/>}
        <BBSearchForm />
        {user?.type === 'DealerUser' && <RecentFloorRequests />}
      </div>
    </div>
  )
}